"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SignalingClientEventType_1 = require("./SignalingClientEventType");
/*
 * [[SignalingClientEvent]] stores an event that can be sent to observers of the SignalingClient.
 */


var SignalingClientEvent = /*#__PURE__*/function () {
  /** Initializes a SignalingClientEvent with the given SignalingClientEventType.
   *
   * @param client Indicates the SignalingClient associated with the event.
   * @param type Indicates the kind of event.
   * @param message SdkSignalFrame if type is ReceivedSignalFrame
   */
  function SignalingClientEvent(client, type, message, closeCode, closeReason) {
    _classCallCheck(this, SignalingClientEvent);

    this.client = client;
    this.type = type;
    this.message = message;
    this.closeCode = closeCode;
    this.closeReason = closeReason;
    this.timestampMs = Date.now();
  }

  _createClass(SignalingClientEvent, [{
    key: "isConnectionTerminated",
    value: function isConnectionTerminated() {
      switch (this.type) {
        case SignalingClientEventType_1.default.WebSocketFailed:
        case SignalingClientEventType_1.default.WebSocketError:
        case SignalingClientEventType_1.default.WebSocketClosing:
        case SignalingClientEventType_1.default.WebSocketClosed:
          return true;

        default:
          return false;
      }
    }
  }]);

  return SignalingClientEvent;
}();

exports.default = SignalingClientEvent;